(function () {
  'use strict';
  function initCollectionDescriptions() {
    document.querySelectorAll('[data-op-collection-description]').forEach(function (wrapper) {
      if (wrapper.getAttribute('data-op-ready') === 'true') return;
      wrapper.setAttribute('data-op-ready', 'true');
      var content = wrapper.querySelector('[data-op-collection-description-content]');
      var button = wrapper.querySelector('[data-op-collection-description-toggle]');
      if (!content || !button) return;

      function assessOverflow() {
        if (window.matchMedia('(min-width: 769px)').matches) {
          button.hidden = true;
          content.classList.remove('is-expanded');
          button.setAttribute('aria-expanded', 'false');
          button.textContent = 'Read more';
          return;
        }
        content.classList.remove('is-expanded');
        button.setAttribute('aria-expanded', 'false');
        button.textContent = 'Read more';
        button.hidden = !(content.scrollHeight > content.clientHeight + 8);
      }

      button.addEventListener('click', function () {
        var expanded = content.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        button.textContent = expanded ? 'Show less' : 'Read more';
      });
      assessOverflow();
      window.addEventListener('resize', assessOverflow);
    });
  }

  function init() {
    initCollectionDescriptions();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
}());

/* Ormskirk Pets: searchable, shortened Brand filters */
(function () {
  'use strict';

  var VISIBLE_BRANDS = 10;

  function normalise(value) {
    var text = String(value || '').toLocaleLowerCase();

    if (typeof text.normalize === 'function') {
      text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return text.replace(/\s+/g, ' ').trim();
  }

  function keepOpenHeightAutomatic(group) {
    var panel = group.querySelector('.collapsible-content');

    if (panel && panel.classList.contains('is-open')) {
      panel.style.height = 'auto';
    }
  }

  function initBrandFilters(root) {
    var scope = root && root.querySelectorAll ? root : document;

    var groups = scope.querySelectorAll(
  '[data-op-filter-title="brand"], ' +
  '[data-op-filter-title="brands"], ' +
  '.collection-sidebar__group--brand, ' +
  '.collection-sidebar__group--brands'
);

    groups.forEach(function (group, groupIndex) {
      if (group.getAttribute('data-op-brand-ready') === 'true') {
        return;
      }

      var inner = group.querySelector('.collapsible-content__inner');
      var list = inner ? inner.querySelector('.tag-list') : null;

      if (!inner || !list) {
        return;
      }

      var items = Array.prototype.slice.call(list.children).filter(
        function (item) {
          return item.tagName === 'LI';
        }
      );

      group.setAttribute('data-op-brand-ready', 'true');

      /*
       * Small brand lists are clearer without an unnecessary
       * search field or View More control.
       */
      if (items.length <= VISIBLE_BRANDS) {
        return;
      }

      items.forEach(function (item) {
        var link = item.querySelector('a');

        item.setAttribute(
          'data-op-brand-name',
          normalise(link ? link.textContent : item.textContent)
        );
      });

      var inputId =
        'OpBrandSearch-' +
        groupIndex +
        '-' +
        Math.random().toString(36).slice(2, 8);

      var tools = document.createElement('div');
      tools.className = 'op-brand-filter-tools';

      tools.innerHTML =
        '<label class="visually-hidden" for="' +
        inputId +
        '">Search brands</label>' +
        '<div class="op-brand-filter-search">' +
          '<svg aria-hidden="true" focusable="false" viewBox="0 0 64 64">' +
            '<path d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10' +
            'a18.58 18.58 0 0 1 18.58 18.58zM54 54L41.94 42"/>' +
          '</svg>' +
          '<input ' +
            'id="' + inputId + '" ' +
            'type="search" ' +
            'class="op-brand-filter-input" ' +
            'placeholder="Search brands..." ' +
            'autocomplete="off">' +
        '</div>';

      inner.insertBefore(tools, list);

      var input = tools.querySelector('.op-brand-filter-input');

      var moreButton = document.createElement('button');
      moreButton.type = 'button';
      moreButton.className = 'op-brand-filter-more';
      moreButton.setAttribute('aria-expanded', 'false');

      var emptyMessage = document.createElement('p');
      emptyMessage.className = 'op-brand-filter-empty';
      emptyMessage.textContent = 'No matching brands found.';
      emptyMessage.hidden = true;

      list.insertAdjacentElement('afterend', moreButton);
      moreButton.insertAdjacentElement('afterend', emptyMessage);

      var expanded = false;

      function render() {
        var query = normalise(input.value);
        var matchingCount = 0;
        var hiddenCount = 0;

        items.forEach(function (item, index) {
          var brandName = item.getAttribute('data-op-brand-name');

          var matches =
            !query ||
            brandName.indexOf(query) !== -1;

          var selected =
            item.classList.contains('tag--active');

          var show =
            matches &&
            (
              query ||
              expanded ||
              index < VISIBLE_BRANDS ||
              selected
            );

          if (matches) {
            matchingCount += 1;
          }

          item.hidden = !show;

          if (!show && !query) {
            hiddenCount += 1;
          }
        });

        if (query) {
          moreButton.hidden = true;
        } else {
          moreButton.hidden =
            !expanded && hiddenCount === 0;

          moreButton.textContent = expanded
            ? 'View fewer brands'
            : 'View ' + hiddenCount + ' more';
        }

        moreButton.setAttribute(
          'aria-expanded',
          expanded ? 'true' : 'false'
        );

        emptyMessage.hidden = matchingCount !== 0;

        keepOpenHeightAutomatic(group);
      }

      input.addEventListener('input', render);
      input.addEventListener('search', render);

      moreButton.addEventListener('click', function () {
        expanded = !expanded;
        render();
      });

      render();
    });
  }

  function init() {
    initBrandFilters(document);

    /*
     * Shopify replaces the collection sidebar after an AJAX
     * filter selection, so watch for newly rendered filters.
     */
    var ajaxResult =
      document.getElementById('CollectionAjaxResult');

    if (
      ajaxResult &&
      ajaxResult.getAttribute('data-op-brand-observer') !== 'true'
    ) {
      ajaxResult.setAttribute(
        'data-op-brand-observer',
        'true'
      );

      new MutationObserver(function () {
        initBrandFilters(ajaxResult);
      }).observe(ajaxResult, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    init
  );
}());

/* =========================================================
   COLLECTION FILTER ACCORDION FALLBACK

   Handles desktop sidebar and mobile filter drawer without
   relying on the theme's shared global collapsible lock.
   ========================================================= */

(function () {
  'use strict';

  if (
    document.documentElement.getAttribute(
      'data-op-filter-accordion-ready'
    ) === 'true'
  ) {
    return;
  }

  document.documentElement.setAttribute(
    'data-op-filter-accordion-ready',
    'true'
  );

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest(
        '.collection-sidebar__group > .tag-list__header'
      );

      if (
        !trigger ||
        !document.body.classList.contains('template-collection')
      ) {
        return;
      }

      var controlId = trigger.getAttribute('aria-controls');
      var content = controlId
        ? document.getElementById(controlId)
        : null;

      if (!content) {
        return;
      }

      /*
       * Prevent the theme's global collapsible listener from
       * attempting to operate on the same filter a second time.
       */
      event.preventDefault();
      event.stopImmediatePropagation();

      var inner = content.querySelector(
        '.collapsible-content__inner'
      );

      var isOpen = trigger.classList.contains('is-open');

      if (isOpen) {
        /*
         * Begin at the currently rendered height before
         * animating the filter back to zero.
         */
        content.style.height =
          content.scrollHeight + 'px';

        content.offsetHeight;

        trigger.classList.remove('is-open');
        trigger.setAttribute(
          'aria-expanded',
          'false'
        );

        content.classList.remove('is-open');

        window.requestAnimationFrame(function () {
          content.style.height = '0px';
        });

        return;
      }

      trigger.classList.add('is-open');
      trigger.setAttribute(
        'aria-expanded',
        'true'
      );

      content.classList.add('is-open');

      content.style.height =
        (
          inner
            ? inner.scrollHeight
            : content.scrollHeight
        ) + 'px';

      /*
       * Once the opening animation finishes, use automatic
       * height so Brand search and View More can expand freely.
       */
      window.setTimeout(function () {
        if (content.classList.contains('is-open')) {
          content.style.height = 'auto';
        }
      }, 380);
    },
    true
  );
}());

/* =========================================================
   MOBILE COLLECTION FILTER DRAWER FALLBACK

   Provides a reliable delegated opener for the mobile Filter
   button, including after Shopify AJAX-reloads the collection.
   ========================================================= */

(function () {
  'use strict';

  if (
    document.documentElement.getAttribute(
      'data-op-mobile-filter-drawer-ready'
    ) === 'true'
  ) {
    return;
  }

  document.documentElement.setAttribute(
    'data-op-mobile-filter-drawer-ready',
    'true'
  );

  document.addEventListener(
    'click',
    function (event) {
      if (
        !window.matchMedia('(max-width: 768px)').matches ||
        !document.body.classList.contains('template-collection')
      ) {
        return;
      }

      var target = event.target;

      if (!(target instanceof Element)) {
        return;
      }

      var button = target.closest(
        '.js-drawer-open-collection-filters'
      );

      if (!button) {
        return;
      }

      var drawer = document.getElementById('FilterDrawer');

      if (!drawer) {
        return;
      }

      /*
       * Stop the button's old direct listener from competing
       * with this delegated handler.
       */
      event.preventDefault();
      event.stopPropagation();

      if (
        !window.theme ||
        typeof window.theme.Drawers !== 'function'
      ) {
        return;
      }

      /*
       * Recreate the drawer controller only if Shopify has
       * replaced the drawer or no controller currently exists.
       */
      if (
        !window.theme.FilterDrawer ||
        window.theme.FilterDrawer.drawer !== drawer
      ) {
        window.theme.FilterDrawer =
          new window.theme.Drawers(
            'FilterDrawer',
            'collection-filters'
          );
      }

      /*
       * Repair an occasional stale state where the JavaScript
       * thinks the drawer is open although its open class has
       * already disappeared.
       */
      if (
        window.theme.FilterDrawer.isOpen &&
        !drawer.classList.contains('drawer--is-open')
      ) {
        window.theme.FilterDrawer.isOpen = false;
      }

      window.theme.FilterDrawer.open(
        null,
        button
      );
    },
    true
  );
}());